import BookingNotConfirmed from './BookingNotConfirmed.component';
export default BookingNotConfirmed;